import {AchievementFiles} from "./AchievementFiles";

export class WinnerOfCompetition {
  international: number = null;
  republic: number = null;
  regional: number = null;
  city: number = null;
  other: number = null;
  international_files: AchievementFiles[] = [];
  republic_files: AchievementFiles[] = [];
  regional_files: AchievementFiles[] = [];
  city_files: AchievementFiles[] = [];
  other_files: AchievementFiles[] = [];
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/personal-achievements/WinnerOfCompetition.ts